import { Box, ResponsiveContext, Text, Image, Grid } from "grommet";
import { take } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { Link, useNavigate } from "react-router-dom";
import ScrollContainer from "../components/ScrollContainer";
import { LeagueViewModel } from "./LeaguesStore";

export const LeagueRow = ({ league, children }: { league: LeagueViewModel; children: React.ReactElement }) => {
    const size = React.useContext(ResponsiveContext);

    const linkProps = league.id ? { to: `/leagues/${league.id}` } : { to: "" };

    return (
        // <Box background={"background"} pad="small" hoverIndicator="background-back" onClick={() => navigate("/leagues/" + league.id)} direction="row" gap="small" align="center">
        //     <Image src={league.logoUri} width="128px"></Image>
        //     <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
        //         {league.name}
        //     </Text>
        // </Box>

        <Link style={{ textDecoration: "none", color: "unset" }} {...linkProps}>
            <Box background={"background"} pad="small" hoverIndicator="background-back" onClick={() => {}}>
                <Grid columns={["130px", "200px", "auto"]} gap="small">
                    <Avatar name={league.name} round={"18px"} size="128px" src={league.logoUri}></Avatar>
                    <Box direction="row" align="center" gap="small">
                        <Box>
                            <Text weight={"bold"} style={{ textTransform: "uppercase" }}>
                                {league.name}
                            </Text>
                            <Text size="small"> {league.seasons?.filter((s) => !s.archived).length || 0} seasons</Text>
                        </Box>
                    </Box>
                    {size !== "small" && (
                        <ScrollContainer direction={"-x"}>
                            <Box direction="row" justify="end" fill gap="medium">
                                {league.seasons
                                    ?.filter((s) => !s.archived)
                                    .map((season) => (
                                        <Box direction="row" key={season.id} align="center" gap="small" width={{ min: "70px" }}>
                                            <Box align="center">
                                                <Avatar name={season.name} round={"18px"} size="70" src={season.logoUri}></Avatar>
                                                <Text>{season.name}</Text>
                                            </Box>
                                        </Box>
                                    ))}
                            </Box>
                        </ScrollContainer>
                    )}
                </Grid>
            </Box>
        </Link>
    );
};
